<template>
  <Dropdown
    position="right"
    class="text-supplement transition-colors hover:text-paragraph"
    @toggle="handleDropdownToggle"
  >
    <template #label>
      <img
        :src="`/flags/${currentLocale.flag}.svg`"
        :alt="`${currentLocale.name} flag`"
        class="h-3.5 w-5 rounded-sm object-cover"
      />
    </template>
    <DropdownSection>
      <DropdownItem
        v-for="locale in availableLocales"
        :key="locale.code"
        @click="changeLocale(locale.code)"
      >
        <div class="flex items-center gap-3">
          <div class="relative h-3.5 w-5 rounded-sm bg-gray-200">
            <img
              v-if="isFlagsLoaded"
              :src="`/flags/${locale.flag}.svg`"
              :alt="`${locale.name} flag`"
              class="absolute inset-0 h-3.5 w-5 rounded-sm object-cover"
            />
          </div>
          {{ locale.name }}
        </div>
      </DropdownItem>
    </DropdownSection>
  </Dropdown>
</template>

<script setup>
const { locale, locales, setLocale } = useI18n()

const user = useUser()
const isFlagsLoaded = ref(false)

const currentLocale = computed(() => locales.value.find(i => i.code === locale.value))
const availableLocales = computed(() => locales.value.filter(i => i.code !== locale.value).sort((a, b) => a.name.localeCompare(b.name)))

const handleDropdownToggle = (isOpen) => {
  if (isOpen) {
    isFlagsLoaded.value = true
  }
}

const changeLocale = async (locale) => {
  setLocale(locale)

  if (user.value) {
    await $larafetch('user/language', {
      method: 'PUT',
      body: {
        language: locale
      }
    })
  }
}
</script>
